"use strict";

import {addressAutocompleteFieldValidation, validateAddressWithGeocoder} from "./address-autocomplete-validation";

function initSolarLeadFormValidation() {
	const solarLeadForm = '.js-solar-lead-form',
		solarLeadInput = '.js-solar-lead-input',
		solarLeadInputWithPattern = '.js-solar-lead-input-with-pattern',
		triggerValidationSolarLeadButton = '.js-trigger-solar-lead-form-validation',
		checkbox = '.js-checkbox-validation',
		select = '.js-select-validation',
		radioButtonGroups = '.js-radio-button-group-validation',
		elementSolarLeadForm = document.querySelector(solarLeadForm);

	if (elementSolarLeadForm) {
		const elementSolarLeadInputs = elementSolarLeadForm.querySelectorAll(solarLeadInput),
			elementValidationSolarLeadButton = elementSolarLeadForm.querySelector(triggerValidationSolarLeadButton),
			elementRadioButtonGroups = elementSolarLeadForm.querySelectorAll(radioButtonGroups),
			elementSelects = elementSolarLeadForm.querySelectorAll(select),
			elementCheckbox = elementSolarLeadForm.querySelectorAll(checkbox),
			optionalInputFieldsWithPattern = elementSolarLeadForm.querySelectorAll(solarLeadInputWithPattern);

		elementSolarLeadInputs.forEach(elementSolarLeadInput => {
			elementSolarLeadInput.addEventListener('keydown', event => {

				if (event.code === 'Enter') {
					event.stopPropagation();
					event.preventDefault();
					solarLeadFieldValidation(elementSolarLeadInput);
				}

			});

			elementSolarLeadInput.addEventListener('blur', function () {
				solarLeadFieldValidation(elementSolarLeadInput);
			});
		});

		elementSelects.forEach(elementSelect => {
			elementSelect.addEventListener('change', function () {
				selectValidationOnClick(elementSolarLeadForm, elementSelects);
			});
		});

		elementRadioButtonGroups.forEach(elementRadioButtonGroup => {
			elementRadioButtonGroup.addEventListener('change', function () {
				radioButtonGroupValidationOnClick(0, elementRadioButtonGroup);
			});
		});

		if (elementValidationSolarLeadButton) {
			elementValidationSolarLeadButton.addEventListener('click', function () {
				radioButtonGroupValidationOnClick(elementRadioButtonGroups);
				selectValidationOnClick(elementSolarLeadForm, elementSelects);
				checkboxValidationOnClick(elementSolarLeadForm, elementCheckbox);
				optionalInputWithPattern(elementSolarLeadForm, optionalInputFieldsWithPattern);
				addressAutocompleteFieldValidation();

				elementSolarLeadInputs.forEach(elementSolarLeadInput => {
					solarLeadFieldValidation(elementSolarLeadInput);
				});
			});
		}

	}

}

function solarLeadFieldValidation(elementSolarLeadInput) {

	const elementInputField = elementSolarLeadInput.closest('.js-solar-lead-field'),
		inputValue = elementSolarLeadInput.value,
		currentPattern = new RegExp(elementSolarLeadInput.pattern);

	let valid = true;

	if (inputValue !== '' || inputValue !== undefined || inputValue !== null) {

		valid = currentPattern.test(inputValue);

	} else {
		valid = false;
	}

	triggerStateClasses(valid, elementSolarLeadInput, elementInputField)

}

function optionalInputWithPattern(elementSolarLeadForm, optionalInputFieldsWithPattern) {

	if (optionalInputFieldsWithPattern.length > 0) {

		optionalInputFieldsWithPattern.forEach(optionalInput => {

			const elementOptionalInputField = optionalInput.closest('.js-solar-lead-field'),
				optionalInputValue = optionalInput.value,
				pattern = new RegExp(optionalInput.pattern);

			let valid = true;

			if (optionalInputValue) {
				valid = pattern.test(optionalInputValue);
			}

			triggerStateClasses(valid, optionalInput, elementOptionalInputField)

		});

	}

}

function radioButtonGroupValidationOnClick(elementRadioButtonGroups, elementRadioButtonUlGroup) {

	if (elementRadioButtonGroups.length > 0) {

		elementRadioButtonGroups.forEach(elementRadioButtonGroup => {

			setRadioButtonGroupState(elementRadioButtonGroup);

		});

	}

	if (elementRadioButtonUlGroup) {

		setRadioButtonGroupState(elementRadioButtonUlGroup);

	}

	function setRadioButtonGroupState(elementRadioButtonGroup) {
		const elementRadioButtons = elementRadioButtonGroup.querySelectorAll('.js-radio-button-validation');

		for (let i = 0; i < elementRadioButtons.length; i++) {

			const isValid = elementRadioButtons[i].checked;

			if (!isValid) {
				elementRadioButtonGroup.classList.add('is-invalid')
			} else {
				elementRadioButtonGroup.classList.remove('is-invalid')
				break;
			}

		}
	}
}

function selectValidationOnClick(elementSolarLeadForm, elementSelects) {

	if (elementSelects.length > 0) {

		elementSelects.forEach(elementSelect => {
			const elementSolarLeadField = elementSelect.closest('.js-solar-lead-field'),
				valid = elementSelect.value;

			triggerStateClasses(valid, elementSelect, elementSolarLeadField)

		})

	}

}

function checkboxValidationOnClick(elementSolarLeadForm, elementCheckbox) {

	if (elementCheckbox.length > 0) {

		elementCheckbox.forEach(elementCheckbox => {
			const elementSolarLeadField = elementCheckbox.closest('.js-solar-lead-field'),
				valid = elementCheckbox.checked;

			triggerStateClasses(valid, elementCheckbox, elementSolarLeadField)

		})

	}
}

function triggerStateClasses(valid, input, parentField) {
	const invalidClass = 'is-invalid'

	if (valid) {
		input.classList.remove(invalidClass);
		parentField.classList.remove(invalidClass);
	} else {
		input.classList.add(invalidClass);
		parentField.classList.add(invalidClass);
	}
}

document.addEventListener("DOMContentLoaded", function () {
	initSolarLeadFormValidation();
});
